export default {
    'multiple-languages': {
        title: 'Versão 2.3: o Keybreak fala sete idiomas',
        excerpt: 'A versão 2.3 traz suporte para vários idiomas, toda a aplicação e o site estão agora disponíveis em sete idiomas, com mais a caminho.',
    },
    'micro-breaks': {
        title: 'Versão 2.2: micropausas',
        excerpt: 'Depois de alguns comentários de utilizadores, a versão 2.2 traz as micropausas: um pequeno aviso no canto do ecrã a cada 10–15 minutos com uma coisa para experimentares.',
    },
    'dynamic-hold-system': {
        title: 'Versão 2.1: retenções mais inteligentes e melhor feedback',
        excerpt: 'A versão 2.1 traz duas coisas: uma forma de aumentar o tempo de retenção na hora e um novo sistema de animações que te mostra exatamente onde estás em cada retenção.',
    },
    'science-of-sitting': {
        title: 'A ciência do sedentarismo: o que a investigação nos diz sobre passar o dia sentado',
        excerpt: 'O comportamento sedentário é um risco para a saúde por si só, em grande medida independente de fazeres ou não exercício. Eis o que a investigação mostra de facto.',
    },
    'benefits-of-moving': {
        title: 'Porque é que mexeres-te mais durante o dia de trabalho faz mesmo diferença',
        excerpt: 'As pausas regulares para te mexeres não ajudam só o corpo, deixam-te mais atento, menos cansado e mais produtivo ao longo do dia.',
    },
    'keybreak-launch': {
        title: 'Keybreak: conhece o teu companheiro inteligente de pausas',
        excerpt: 'Depois de meses de desenvolvimento, temos o prazer de anunciar que o Keybreak já está oficialmente disponível, gratuito para transferir em Mac e Windows.',
    },
}
